import {createAction, props} from "@ngrx/store";
import {PageEvent} from "@angular/material/paginator";
import {Sort} from "@angular/material/sort";
import {TrunkNotice} from "@knust/api-interfaces";

export const loadTrunkNotices = createAction('[TrunkNotice] Load TrunkNotice');

export const loadTrunkNoticesSuccess = createAction(
  '[TrunkNotice/API] Load TrunkNotice Success',
  props<{ trunkNotice: TrunkNotice[], total: number }>()
);

export const loadTrunkNoticesFailure = createAction(
  '[TrunkNotice/API] Load TrunkNotice Failure',
  props<{ error: any }>()
);

export const setSelectedTrunkNotice = createAction(
  '[TrunkNotice/API] Set selected TrunkNotice',
  props<{ id: number }>()
);

export const loadTrunkNoticeDetailUnneeded = createAction(
  '[TrunkNotice/API] Load TrunkNotice Detail Unneeded'
);

export const loadTrunkNoticeDetailSuccess = createAction(
  '[TrunkNotice/API] Load TrunkNotice Detail Success',
  props<{ trunkNotice: TrunkNotice }>()
);

export const loadTrunkNoticeDetailFailure = createAction(
  '[TrunkNotice/API] Load TrunkNotice Detail Failure',
  props<{ error: any }>()
);

export const setTrunkNoticePage = createAction(
  '[TrunkNotice/API] Set Page',
  props<{ page: PageEvent }>()
);

export const setTrunkNoticeTerm = createAction(
  '[TrunkNotice/API] Set Term',
  props<{ term: string }>()
);

export const setTrunkNoticeSort = createAction(
  '[TrunkNotice/API] Set Sort',
  props<{ sort: Sort | null }>()
);

export const clearTrunkNotice = createAction(
  '[TrunkNotice/API] Clear'
);

export const createTrunkNotice = createAction(
  '[TrunkNotice/API] Create TrunkNotice',
  props<{ trunkNotice: Omit<TrunkNotice, 'id'> }>()
);

export const updateTrunkNotice = createAction(
  '[TrunkNotice/API] Update TrunkNotice',
  props<{ trunkNotice: TrunkNotice }>()
);

export const saveTrunkNoticeSuccess = createAction(
  '[TrunkNotice/API] Save TrunkNotice Success',
  props<{ trunkNotice: TrunkNotice, insert: boolean }>()
);

export const saveTrunkNoticeFailure = createAction(
  '[TrunkNotice/API] Save TrunkNotice Failure',
  props<{ error: any }>()
);

export const deleteTrunkNotice = createAction(
  '[TrunkNotice/API] Delete TrunkNotice',
  props<{ trunkNotice: TrunkNotice }>()
);

export const deleteTrunkNoticeSuccess = createAction(
  '[TrunkNotice/API] Delete TrunkNotice Success',
  props<{ id: number | string }>()
);

export const deleteTrunkNoticeFailure = createAction(
  '[TrunkNotice/API] Delete TrunkNotice Failure',
  props<{ error: any }>()
);

export const restoreTrunkNotice = createAction(
  '[TrunkNotice/API] Restore TrunkNotice',
  props<{ element: TrunkNotice }>()
);

export const restoreTrunkNoticeSuccess = createAction(
  '[TrunkNotice/API] Restore TrunkNotice Success',
  props<{ trunkNotice: TrunkNotice }>()
);

export const restoreTrunkNoticeFailure = createAction(
  '[TrunkNotice/API] Restore TrunkNotice Failure',
  props<{ error: any }>()
);
